import { format } from 'date-fns'

const ExpandableIncidetTable = ({ data }) => {
    return (
        <>
            <article className="expandedComponentWrapper p-2">
                <p className={`fw-bold mb-3`}>
                    Description:{' '}
                    <span className="fw-normal">{data?.description_tx}</span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Score: <span className="fw-normal">{data?.score_nr !== undefined ? Math.round(Number(data?.score_nr)) : ''}</span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Status:{' '}
                    <span className="fw-normal">
                        {data?.ref_status_description_tx}
                    </span>
                </p>
                <p className={`fw-bold mb-3`}>
                    User Name:{' '}
                    <span className="fw-normal">{data?.user_name_tx}</span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Device Name:{' '}
                    <span className="fw-normal">{data?.device_name_tx}</span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Congregation:{' '}
                    <span className="fw-normal">{data?.wmrc_division}</span>
                </p>
                <p className={`fw-bold mb-3`}>
                    Date:{' '}
                    <span className="fw-normal">
                        {data?.event_dt &&
                            format(
                                new Date(data?.event_dt),
                                'MM-dd-yyyy h:mm a'
                            )}
                    </span>
                </p>
            </article>
        </>
    )
}
export default ExpandableIncidetTable
